// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"29208cfe","511":"d5074751","660":"cca3d192"}[chunkId] + ".css";
};